import { useMutation, useQueryClient } from "react-query";
import { createSubAdminService,updateSubAdminStatusService,removeCareHomeService,assignCareHomesService,getAssignedCareHomesService, switchCareHomeService,deleteSubAdminService,
  getCareHomesForAssignmentService,resendSubAdminInvitationService
} from "./SubAdmins.service";
import { userKeys } from "pages/Users/Users.query";
import { useQuery } from "react-query";
import { Alert } from "utils";

export const useCreateSubAdminMutation = () => {
  const queryClient = useQueryClient();
  return useMutation((payload) => createSubAdminService(payload), {
    onSuccess: () => {
      Alert.success("Sub-Admin created successfully!");
      queryClient.invalidateQueries(userKeys.users);
    },
  });
};
export const useUpdateSubAdminStatusMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(
    ({ userId, status }) =>
      updateSubAdminStatusService(userId, status),
    {
      onSuccess: () => {
        Alert.success("Sub Admin status updated successfully");
        queryClient.invalidateQueries(userKeys.users);
      },
    }
  );
};

export const useAssignCareHomesMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(
  ({ subAdminId, assignments }) =>
    assignCareHomesService(
      subAdminId,
      assignments
    ),
  {
    onSuccess: () => {
      Alert.success("Care Home assigned successfully");

      queryClient.invalidateQueries([
        "assigned-carehomes",
      ]);
    },
  }
);
};

export const useRemoveCareHomeMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(
    ({ subAdminId, careHomeIds }) =>
      removeCareHomeService(
        subAdminId,
        careHomeIds
      ),
    {
      onSuccess: () => {
        Alert.success("Care Home removed successfully");

        queryClient.invalidateQueries([
          "assigned-carehomes",
        ]);
      },
    }
  );
};

export const useGetAssignedCareHomesQuery = (
  subAdminId
) => {
  return useQuery(
    ["assigned-carehomes", subAdminId],
    () =>
      getAssignedCareHomesService(
        subAdminId
      ),
    {
      enabled: !!subAdminId,
    }
  );
};

export const useSwitchCareHomeMutation = () => {
  return useMutation(
    (careHomeId) => switchCareHomeService(careHomeId)
  );
};

export const useDeleteSubAdminMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (userId) => deleteSubAdminService(userId),
    {
      onSuccess: () => {
        Alert.success("Sub Admin deleted successfully");
        queryClient.invalidateQueries(userKeys.users);
      },
    }
  );
};
export const useGetCareHomesForAssignmentQuery = () => {
  return useQuery(
    ["carehomes-for-assignment"],
    () => getCareHomesForAssignmentService()
  );
};
export const useResendSubAdminInvitationMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (userId) => resendSubAdminInvitationService(userId),
    {
      onSuccess: () => {
        Alert.success("Invitation email sent successfully.");
        queryClient.invalidateQueries(["users"]);
      },
      onError: (error) => {
        Alert.error(error?.message || "Failed to resend invitation.");
      },
    }
  );
};
